// extracted by mini-css-extract-plugin
module.exports = {"content":"healthcare_content__owBZB","healthCaseBtn":"healthcare_healthCaseBtn__IoD2w","healthCaseFlex":"healthcare_healthCaseFlex__lDQwM"};